// D8.4.1 — Constantes compartidas de ContactProfile360Modal (paleta + z-index).

export const D11 = {
  green: "#00C853",
  blue: "#0056b3",
  orange: "#FF9800",
  placeholder: "#9E9E9E"
};

/** El Drawer usa Modal con este z-index; el menú por defecto de `Select` queda más bajo (~1300) y no se ve. */
export const CONTACT360_DRAWER_Z = 1400;
export const CONTACT360_SELECT_MENU_Z = 2000;

/** Claves texto/código persistidas en `profileData` (0287‑H); no incluir `conexionOrigen` ni notas texto plano legacy. */
export const PROFILE_PATCH_KEYS = [
  "fechaNacimiento",
  "comoNosConocio",
  "servicioFavorito",
  "profesional",
  "horarioHabitual",
  "tipoCabello",
  "alergias",
  "metodoPago",
  "frecuenciaVisita",
  "asesorAsignado"
];

export const REFERRAL_SOURCE_OPTIONS = [
  { value: "facebook", label: "Facebook" },
  { value: "youtube", label: "YouTube" },
  { value: "web", label: "Página web" },
  { value: "recomendacion", label: "Recomendación familiar o amigo" },
  { value: "google", label: "Google / búsqueda" },
  { value: "instagram", label: "Instagram" },
  { value: "tiktok", label: "TikTok" },
  { value: "whatsapp", label: "WhatsApp / otro chat" },
  { value: "otros", label: "Otros" }
];

export const HORARIO_HABITUAL_OPTIONS = [
  { value: "manana", label: "Mañana" },
  { value: "tarde", label: "Tarde" },
  { value: "noche", label: "Noche" },
  { value: "fin_semana", label: "Fin de semana" },
  { value: "flexible", label: "Flexible / coordinar" },
  { value: "entre_semana", label: "Entre semana" }
];

export const FRECUENCIA_VISITA_OPTIONS = [
  { value: "7", label: "Cada ~7 días (semanal)" },
  { value: "14", label: "Cada ~14 días (quincenal)" },
  { value: "30", label: "Cada ~30 días (mensual)" },
  { value: "60", label: "Cada ~60 días (bimestral)" },
  { value: "90", label: "Cada ~90 días (trimestral)" },
  { value: "esporadico", label: "Esporádico / primera vez" },
  { value: "no_indica", label: "Sin indicar" }
];

export const DEFAULT_METODO_PAGO_OPTIONS = [
  { value: "efectivo", label: "Efectivo" },
  { value: "tarjeta", label: "Tarjeta" },
  { value: "transferencia", label: "Transferencia" },
  { value: "yape", label: "Yape" },
  { value: "plin", label: "Plin" },
  { value: "otro", label: "Otro" }
];
